import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Shape",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.66 9.19323C16.66 8.5905 16.6059 8.01095 16.5055 7.45459H8.5V10.7425H13.0746C12.8775 11.8051 12.2786 12.7053 11.3784 13.308V15.4407H14.1255C15.7327 13.961 16.66 11.7819 16.66 9.19323Z",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.49997 17.5C10.795 17.5 12.7191 16.7389 14.1254 15.4407L11.3784 13.3079C10.6173 13.8179 9.64361 14.1193 8.49997 14.1193C6.28611 14.1193 4.41224 12.6241 3.74383 10.615H0.904053V12.8173C2.30269 15.5952 5.17724 17.5 8.49997 17.5Z",
				fill: "#34A853"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.74387 10.615C3.57387 10.105 3.47728 9.56025 3.47728 9.00002C3.47728 8.43979 3.57387 7.89502 3.74387 7.38502V5.18274H0.904092C0.32841 6.33024 0 7.62842 0 9.00002C0 10.3716 0.32841 11.6698 0.904092 12.8173L3.74387 10.615Z",
				fill: "#FBBC05"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_4",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.49997 3.88069C9.74793 3.88069 10.8684 4.30955 11.7493 5.15183L14.1873 2.71387C12.7152 1.34227 10.7911 0.5 8.49997 0.5C5.17724 0.5 2.30269 2.40478 0.904053 5.18273L3.74383 7.38501C4.41224 5.37592 6.28611 3.88069 8.49997 3.88069Z",
				fill: "#EA4335"
			})
		]
	})
});
export default SvgGoogle;
